import React, { useContext, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import { NavbarContext } from "../../context";
import { socialLinks } from "../../data/portfolioData";
import resumePdf from "../../Assets/LeManhHung_CV.pdf";

export const Contact = () => {
  const { ref, inView } = useInView({ threshold: 0.25 });
  const setPage = useContext(NavbarContext);

  useEffect(() => {
    if (inView) setPage("contact");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const valid =
    form.name.trim().length > 0 &&
    /\S+@\S+\.\S+/.test(form.email) &&
    form.message.trim().length > 0;
  const change = (field) => (e) => setForm((prev) => ({ ...prev, [field]: e.target.value }));

  return (
    <section
      ref={ref}
      id="contact-page"
      className="contact-section"
      aria-labelledby="contact-heading"
    >
      <div className="container-wide">
        <h2 id="contact-heading" className="section-heading">
          Let's work together.
        </h2>

        <div className="contact-layout">
          <form
            id="contactform"
            className="contact-form"
            action="https://formspree.io/f/mbjbvlpv"
            method="POST"
            name="contact"
          >
            <input type="hidden" name="_subject" value="Portfolio message" />

            <div className="form-row">
              <label htmlFor="contact-name" className="form-label">Name</label>
              <input
                id="contact-name"
                name="name"
                type="text"
                className="form-input"
                value={form.name}
                onChange={change("name")}
                autoComplete="name"
                required
              />
            </div>

            <div className="form-row">
              <label htmlFor="contact-email" className="form-label">Email</label>
              <input
                id="contact-email"
                name="email"
                type="email"
                className="form-input"
                value={form.email}
                onChange={change("email")}
                autoComplete="email"
                required
              />
            </div>

            <div className="form-row">
              <label htmlFor="contact-message" className="form-label">Message</label>
              <textarea
                id="contact-message"
                name="message"
                className="form-textarea"
                placeholder="Where is your business losing customers or time?"
                value={form.message}
                onChange={change("message")}
                rows={5}
                required
              />
            </div>

            <button
              type="submit"
              id="contact-submit-btn"
              className="form-submit"
              disabled={!valid}
            >
              Send message
              <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </form>

          <div className="contact-info-block">
            <p className="contact-intro">
              <strong>Tell me where your business is losing customers or time.</strong>{" "}
              I will tell you honestly whether software is the right fix, and what it would take.
              I work remote from Quy Nhơn, Vietnam, with clients in the U.S. and Vietnam, and
              I am also open to delivery lead roles. I usually reply within a day.
            </p>

            <ul className="contact-links-list" aria-label="Contact links">
              {socialLinks.map((item) => (
                <li key={item.platform}>
                  <a
                    href={item.url}
                    target={item.platform !== "Email" ? "_blank" : undefined}
                    rel="noopener noreferrer"
                    className="contact-link-row"
                  >
                    <span>
                      <span className="contact-link-platform">{item.platform}</span>
                      <br />
                      <span className="contact-link-handle">{item.handle}</span>
                    </span>
                  </a>
                </li>
              ))}
            </ul>

            <a
              href={resumePdf}
              target="_blank"
              rel="noopener noreferrer"
              id="resume-download-link"
              className="resume-line"
            >
              <svg width="13" height="13" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <path d="M8 2v9M4 8l4 4 4-4M2 14h12" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Download resume (PDF)
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
